import { P2GLink, P2GText } from '@parcel2go/core-ui';
import { LinkModel } from './LinkModel';
import { useAuth } from 'react-oidc-context';
import { useAnalytics, useTenant } from '@parcel2go/npm-p2g-app';
import useSWR from 'swr';
import { authenticatedFetchWithTenantAnalytics } from '~/lib/fetch';
import { capturePromiseException } from '~/lib/metrics';
import { LABEL_API } from '~/lib/constants';
import BrSplitter from '~/apps/smartsend/lib/helpers/BrSplitter';
import { useLinkTitle } from './useLinkTitle';
import { useEffect } from 'react';

export interface props {
  link: LinkModel;
  tag: string;
  labelStatus: string;
  onDownloaded?: () => void;
}

type LabelData = {
  result: {
    preSignedUrl: string;
  };
  success: boolean;
  error: object;
};

const PreSignedLink = ({ link, onDownloaded }: props) => {
  const { title } = useLinkTitle();
  const { user } = useAuth();
  const { tenant, settings } = useTenant();
  const { session } = useAnalytics();

  const { data, isLoading } = useSWR<LabelData>(
    `${LABEL_API}${link.Href}`,
    () =>
      authenticatedFetchWithTenantAnalytics(user, tenant, settings, session, `${LABEL_API}${link.Href}`)
        .then((res) => res.json())
        .catch(capturePromiseException),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
      revalidateOnMount: false,
      refreshInterval: (d) => (d === undefined ? 1000 : d?.result?.preSignedUrl ? 0 : 5000)
      // Refresh every second if we dont have a pre-signed URL
    }
  );

  useEffect(() => {
    if (data?.result?.preSignedUrl && onDownloaded) {
      onDownloaded();
    }
  }, [onDownloaded, data?.result?.preSignedUrl]);

  if (isLoading || !data?.result?.preSignedUrl) {
    return <P2GText varian="body2">Loading...</P2GText>;
  }

  return (
    <P2GLink target="_blank" href={data.result.preSignedUrl}>
      <BrSplitter label={title(link)} />
    </P2GLink>
  );
};

export default PreSignedLink;
